export default storiesFeed = () => {

	let storiesFeed = document.querySelector('.m__sfeed');
	if(storiesFeed){

		//Deal with fixed filters on mobile
		document.querySelector('body').classList.add('mobile-quick-links');

		let loadMoreButton 	= document.querySelector('.js__sfeed__load-more');
		if(loadMoreButton){
			loadMoreButton.addEventListener('click', (event) => {
				event.preventDefault(); //Stop the link firing normally !

				let loadMoreData 	= document.querySelector('.js__sfeed__data');
				let loadMoreSection = document.querySelector('.js__sfeed-load-articles-here');

				let ajaxData = new FormData();
				ajaxData.append( 'action', 'ajaxGetStories' );
				ajaxData.append( 'nonce', loadMoreData.dataset.nonce );
				ajaxData.append( 'count', (loadMoreData.dataset.paged * 9) );
				ajaxData.append( 'currentCat',loadMoreData.dataset.currentcat);
				ajaxData.append( 'postNotIn', loadMoreData.dataset.postnotin );
				ajaxData.append( 'catNotIn', loadMoreData.dataset.catnotin );

				fetch(igniteAjax.ajaxurl, {
					method: 'POST',
					body: ajaxData,

				})
				.then((response) => response.text())
				.then((data) => {
					let jsonData = JSON.parse(data);
					if(jsonData.message == 'no-stories'){
						loadMoreButton.classList.add('hidden');
					}else{
						loadMoreSection.innerHTML += jsonData.data;
						loadMoreData.dataset.paged = loadMoreData.dataset.paged + 1;
					}
					if(jsonData.numPostsReturned < 9){
						loadMoreButton.classList.add('hidden');
					}
				})
				.catch((error) => {
					console.error(error);
				});
			});
		}

		//Handle toggle of mobile 'quick links' nav
		let sfeedMobileToggle = document.querySelector(".js__sfeed-toggle");
		let sfeedMobileFilters = document.querySelector(".js__sfeed__filters");
		if(sfeedMobileToggle){
			sfeedMobileToggle.addEventListener('click',(event) => {
				event.preventDefault();
				sfeedMobileFilters.classList.toggle('open');
				document.querySelector('#js__body').classList.toggle('js__popup-active');
			});

		}
	}
}
